import { ReactNode } from 'react';
import './Text.css';

interface TextProps {
    children: ReactNode;
    type?: 'title' | 'subtitle' | 'body' | 'disclaimer-title' | 'disclaimer' | 'small';
    className?: string;
}

const Text = ({ children, type = 'body', className }: TextProps) => {
    if (type === 'title') {
        return <h1 className={`text-${type} ${className || ''}`}>{children}</h1>;
    }
    
    if (type === 'subtitle') {
        return <h2 className={`text-${type} ${className || ''}`}>{children}</h2>;
    }

    return <div className={`text-${type} ${className || ''}`}>{children}</div>;
}

export default Text;